import { useEffect, useRef } from "react";

export const RegExEmail =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const PRECIO_REGEX = /^(0|[1-9][0-9]*)$/
export const REGEX_PASSWORD = /^[a-zA-Z0-9]{6,14}$/;

export const formatSimpelDate = async (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so add 1
    const day = date.getDate().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };
  
  export const useDidUpdateEffect = (fn, inputs) => {
    const didMountRef = useRef(false) 
    useEffect(() => {
        if(didMountRef.current){
            return fn()
        }else{
            didMountRef.current = true
        }
    }, inputs)
}